import { Tag as RACTag } from "react-aria-components";
import { css } from "../../../../styled-system/css";
import { token } from "../../../../styled-system/tokens";
import { Button } from "./Button";
import { FaX } from "react-icons/fa6";

export const defaultTagColor = token("colors.trellisPalette.3");

interface TagProps {
  tag: {
    id: string;
    label: string;
  };
  onRemove?: (tagToRemove: string) => void;
  isDisabled?: boolean;
  color?: string;
}

const tagStyles = css({
  display: "flex",
  gap: "xsmall",
  alignItems: "center",
  borderRadius: "15px",
  paddingY: "xxsmall",
  paddingX: "small",
  color: "white",
  fontSize: "small",
  fontWeight: 600,
  backgroundColor: "var(--tag-color)",
});

const Tag = ({ tag, onRemove, isDisabled, color }: TagProps) => (
  <RACTag
    key={tag.id}
    id={tag.id}
    textValue={tag.label}
    className={tagStyles}
    style={{ "--tag-color": color ?? defaultTagColor } as React.CSSProperties}
  >
    {({ allowsRemoving }) => (
      <>
        {tag.label}
        {!isDisabled && (onRemove || allowsRemoving) && (
          <Button variant="contentOnly" slot="remove" onPress={onRemove ? () => onRemove(tag.id) : undefined}>
            <FaX className={css({ fontSize: "xxsmall", fontWeight: "bold" })} />
          </Button>
        )}
      </>
    )}
  </RACTag>
);

export default Tag;
